<div class="row dashboard" #dashboardContainer>
    <div class="col-12">
        <router-outlet></router-outlet>
    </div>
</div>